import { Button } from "../ui/button";
// import { Separator } from "../ui/separator";

export function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-16 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div>
            <h3 className="text-xl mb-4">Sky Grid</h3>
            <p className="text-gray-400 mb-4">
              AI研修
            </p>
            <Button className="bg-white text-gray-900 hover:bg-gray-100" asChild>
              <a href="https://skygrid.co.jp/contact/" target="_blank" rel="noopener noreferrer">
                お問い合わせ
              </a>
            </Button>
          </div>
          
          <div>
            <h4 className="mb-4">サービス</h4>
            <ul className="space-y-2 text-gray-400">
              <li><a href="#" className="hover:text-white transition-colors">AI研修プログラム</a></li>
              <li><a href="#" className="hover:text-white transition-colors">助成金申請サポート</a></li>
              <li><a href="#" className="hover:text-white transition-colors">カリキュラム設計</a></li>
              <li><a href="#" className="hover:text-white transition-colors">フォローアップ</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="mb-4">サポート</h4>
            <ul className="space-y-2 text-gray-400">
              <li><a href="#" className="hover:text-white transition-colors">よくある質問</a></li>
              <li><a href="#" className="hover:text-white transition-colors">資料ダウンロード</a></li>
              <li><a href="#" className="hover:text-white transition-colors">お問い合わせ</a></li>
              <li><a href="#" className="hover:text-white transition-colors">パートナー紹介</a></li>
            </ul>
          </div>
        </div>
        
        <div className="bg-gray-700 h-px mb-8" />
        
        <div className="flex flex-col md:flex-row justify-between items-center text-gray-400">
          <div className="mb-4 md:mb-0">
            <p>&copy; 2025 Sky Grid. All rights reserved.</p>
          </div>
          <div className="flex space-x-6">
            <a href="#" className="hover:text-white transition-colors">プライバシーポリシー</a>
            <a href="#" className="hover:text-white transition-colors">利用規約</a>
            <a href="#" className="hover:text-white transition-colors">特定商取引法</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
